module.exports = __webpack_public_path__ + "img/07-phone-verify.6217120e.png";